import React, { useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Alert, Container, Form, Button, Spinner, Card } from 'react-bootstrap';
import { useFormik } from 'formik';
import { userActions } from '../../../actions';
import { FormField } from '../../common/Forms';
import { renderErrors } from '../../common/Forms/utils';
import { getValidationSchemaForFields } from '../../../util';

const userFields = [
    {
        id: 'email',
        name: 'Email',
        inputType: 'email',
        required: true,
    },
    {
        id: 'pass',
        name: 'Пароль',
        inputType: 'password',
        required: true,
    },
    {
        id: 'confirmPass',
        name: 'Повторить пароль',
        inputType: 'password',
        required: true,
    },
    {
        id: 'name',
        name: 'Отображаемое имя (никнейм)',
        inputType: 'text',
        required: true,
    },
    {
        id: 'surname',
        name: 'Фамилия',
        inputType: 'rustext',
        required: true,
    },
    {
        id: 'firstname',
        name: 'Имя',
        inputType: 'rustext',
        required: true,
    },
    {
        id: 'patronimic',
        name: 'Отчество',
        inputType: 'rustext',
    },
    {
        id: 'gender',
        name: 'Пол',
        inputType: 'sex',
    },
    {
        id: 'birthDate',
        name: 'Дата рождения',
        inputType: 'date',
    },
    {
        id: 'city',
        name: 'Город проживания',
        inputType: 'rustext',
    },
    {
        id: 'club',
        name: 'Клуб',
        inputType: 'text',
    },
    {
        id: 'phone',
        name: 'Телефон',
        inputType: 'phone',
    },
    {
        id: 'vkUrl',
        name: 'Страница профиля ВК',
        inputType: 'vkUrl',
    },
    {
        id: 'acceptRules',
        name: 'Согласен с правилами и политикой конфиденциальности фестиваля',
        inputType: 'checkbox',
        required: true,
    },
];

const initialFormData = {
    email: '',
    name: '',
    surname: '',
    firstname: '',
    patronimic: '',
    gender: '',
    birthDate: '',
    city: '',
    club: '',
    phone: '',
    vkUrl: '',
    pass: '',
    confirmPass: '',
    acceptRules: false,
};

function OneField(props) {
    return (
        <Form.Group>
            <FormField {...props} />
        </Form.Group>
    );
}

function RegPage(props) {
    const { registering, errors, register, clearErrors } = props;

    const userSchema = useMemo(() => {
        return getValidationSchemaForFields(userFields);
    }, []);

    useEffect(() => {
        return () => clearErrors();
    }, [clearErrors]);

    const handleSubmit = useCallback(
        (values) => {
            const userData = userSchema.cast(values);
            register(userData);
        },
        [register, userSchema]
    );

    const formik = useFormik({
        initialValues: initialFormData,
        validate: userSchema.validate,
        onSubmit: handleSubmit,
    });

    const handleChange = useCallback(
        (value, name) => {
            if (errors && errors[name]) clearErrors();
        },
        [errors, clearErrors]
    );

    const submitting = formik.isValidating || registering;

    return (
        <Container className="my-3 my-sm-5">
            <Card style={{ maxWidth: 450 }} className="mx-auto">
                <Card.Header>
                    <Card.Title>Регистрация</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Card.Text>
                        Будем признательны, если Вы заполните все поля формы, не зависимо от их обязательности. Для нас
                        это очень важно. Спасибо.
                    </Card.Text>
                    <Form onSubmit={formik.handleSubmit} noValidate>
                        {userFields.map((field) => (
                            <OneField
                                key={field.id}
                                field={field}
                                formik={formik}
                                errors={errors}
                                onChange={handleChange}
                            />
                        ))}

                        {errors && errors.globalError && (
                            <Alert variant="danger">{renderErrors(errors.globalError)}</Alert>
                        )}

                        <Form.Group className="text-center">
                            <Button variant="outline-primary" type="submit" className="px-5" disabled={submitting}>
                                {submitting && (
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                )}
                                <span>Создать</span>
                            </Button>
                        </Form.Group>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}

function mapStateToProps(state) {
    const { registering, errors } = state.reg;
    return { registering, errors };
}

const actionsToProps = {
    register: userActions.register,
    clearErrors: userActions.clearErrors,
};

export default connect(mapStateToProps, actionsToProps)(RegPage);
